console.log('functions.js');

// make anchor links scroll smoothy
$(".sliding-link").click(function(e) {
	e.preventDefault();
	var aid = $(this).attr("href");
	$('html,body').animate({scrollTop: $(aid).offset().top},'slow');
});

// correct label click
$('label').click(function(e){
	e.stopImmediatePropagation();
});



// open / close fs menu
$('.open-fs').click(function(){
	$('body').toggleClass('fs-menu-open');
	$('#fs-menu').css('opacity', '1');
});


$('#fs-menu .bg, .close-fs-menu').click(function(){
	$('body').toggleClass('fs-menu-open');
});

$('#fs-menu .has-sub').click(function(event){
	event.stopPropagation();
	$(this).toggleClass('open');
	$(this).children('.sub').slideToggle();
});

/*
// open / close cart menu
$('.open-cart').click(function() {
	$('body').addClass('cart-menu-open');
	$('#cart-menu').css('opacity', '1');
});

$('.close-cart, .fs-bg').click(function() {
	$('body').removeClass('cart-menu-open');
});
*/

$(document).keyup(function(e) {
    if(e.key === "Escape") {
		$('body').removeClass('cart-menu-open');
	}
});

// cookies popup
$('#cookie-popup a, #cookie-popup button').click(function(){
	$('#cookie-popup').fadeOut(600);
});

// doc ready functions
$(document).ready(function() {

    /*
	// validate form
	$("#newsletter-form").validate({
		highlight: function (element){
			$(element).closest(".form-line").addClass("error");
		},
		unhighlight: function (element){
			$(element).closest(".form-line").removeClass("error");
		}
	});

	// cookies popup
	setTimeout(function(){
		$('#cookie-popup').fadeIn(600);
	}, 3000);
    */

});